import List from "@/components/list";
import Bus from "../Bus.js";

const Table = args => {
  const RCSelectionChange = args.listeners["selection-change"] || function() {};

  function handleDelete({ row }) {
    Bus.$emit("deletePeriod", row);
  }

  function handleUpdate({ row }) {
    Bus.$emit("updatePeriod", row);
  }

  const Deal = ({ props: { vo } }) => {
    const dealConf = [
      ["icon-edit", "编辑", () => handleUpdate(vo), "periodicalPeriod:update"],
      ["icon-delete", "删除", () => handleDelete(vo), "periodicalPeriod:delete"]
    ];

    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };
  const AccountTableConfig = [
    {
      label: "期刊年份",
      prop: "periodicalYear",
      minWidth: "100"
    },
    {
      label: "期刊期次",
      prop: "currentPeriod",
      minWidth: "100"
    },
    {
      label: "总期次",
      prop: "totalPeriod",
      minWidth: "100"
    },
    {
      label: "出版时间",
      prop: "publishDate",
      minWidth: "140"
    },
    {
      label: "操作",
      minWidth: "100",
      fixed: "right",
      render: vo => <Deal vo={vo} />
    }
  ];
  return (
    <div>
      <List
        {...args}
        onSelectionChange={RCSelectionChange}
        talbeCols={AccountTableConfig}
      />
    </div>
  );
};

export default Table;
